import type { ProtectYearData } from "./ProtectChart";

const ROWS = [
  {
    id: "5d5f0eaf-0827-4785-9bd0-3f89bd45df4b",
    name: "Prakash, ContactOneThreeZero",
    trueIQProtectScore: 0,
  },
  {
    id: "155618cb-e6a4-4f9b-8a45-9f61e1662c16",
    name: "centercontact, review",
    trueIQProtectScore: 0,
  },
  {
    id: "fad1ae80-aff5-404a-869d-aa3df9ea27f7",
    name: "Prakash, ContactOne",
    trueIQProtectScore: 0,
  },
];

export const BS_PROTECT_DUMMY: ProtectYearData[] = [
  {
    planYear: 1,
    year: 2026,
    insuredAge: null,
    combinedTrueIQIndex: 122.0,
    shareholderValue: { actual: 0, projected: 100_000 },
    deathBenefit: { actual: 0, projected: 130_000 },
    livingBenefit: { actual: 0, projected: 118_000 },
    disability: { actual: 0, projected: 112_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [123.5, 122.0, 120.5][i] })),
  },

  {
    planYear: 2,
    year: 2027,
    insuredAge: null,
    combinedTrueIQIndex: 115.0,
    shareholderValue: { actual: 0, projected: 150_000 },
    deathBenefit: { actual: 0, projected: 178_000 },
    livingBenefit: { actual: 0, projected: 168_000 },
    disability: { actual: 0, projected: 158_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [116.0, 115.0, 114.0][i] })),
  },

  {
    planYear: 3,
    year: 2028,
    insuredAge: null,
    combinedTrueIQIndex: 82.0,
    shareholderValue: { actual: 0, projected: 220_000 },
    deathBenefit: { actual: 0, projected: 192_000 },
    livingBenefit: { actual: 0, projected: 178_000 },
    disability: { actual: 0, projected: 165_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [83.0, 82.0, 81.0][i] })),
  },

  {
    planYear: 4,
    year: 2029,
    insuredAge: null,
    combinedTrueIQIndex: 74.0,
    shareholderValue: { actual: 0, projected: 300_000 },
    deathBenefit: { actual: 0, projected: 235_000 },
    livingBenefit: { actual: 0, projected: 215_000 },
    disability: { actual: 0, projected: 200_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [75.0, 74.0, 73.0][i] })),
  },

  {
    planYear: 5,
    year: 2030,
    insuredAge: null,
    combinedTrueIQIndex: 108.0,
    shareholderValue: { actual: 0, projected: 400_000 },
    deathBenefit: { actual: 0, projected: 440_000 },
    livingBenefit: { actual: 0, projected: 428_000 },
    disability: { actual: 0, projected: 412_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [109.0, 108.0, 107.0][i] })),
  },

  {
    planYear: 6,
    year: 2031,
    insuredAge: null,
    combinedTrueIQIndex: 138.0,
    shareholderValue: { actual: 0, projected: 520_000 },
    deathBenefit: { actual: 0, projected: 735_000 },
    livingBenefit: { actual: 0, projected: 710_000 },
    disability: { actual: 0, projected: 690_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [139.5, 138.0, 136.5][i] })),
  },

  {
    planYear: 7,
    year: 2032,
    insuredAge: null,
    combinedTrueIQIndex: 155.0,
    shareholderValue: { actual: 0, projected: 680_000 },
    deathBenefit: { actual: 0, projected: 1_080_000 },
    livingBenefit: { actual: 0, projected: 1_040_000 },
    disability: { actual: 0, projected: 1_000_000 },
    rows: ROWS.map((r, i) => ({ ...r, trueIQProtectScore: [157.0, 155.0, 153.0][i] })),
  },
];
